<mat-toolbar class="sidemenu-toolbar">
  <i class="icon mdi mdi-window-restore"></i>
  <span class="title">Pages</span>
</mat-toolbar>
<mat-accordion class="mat-list-custom" togglePosition="before" displayMode="flat" *ngIf="pagesdata && pagesdata.length > 0">
  <ng-container *ngFor="let page of pagesdata;let pageIndex = index">
    <mat-expansion-panel [expanded]="page?.open || false">
      <mat-expansion-panel-header [class.active]="page?.open || false" class="mat-list-item" mat-ripple (click)="pageDetailsSetter(page)">
          <mat-panel-title class="item-fill">
            <span>{{ page.pageName | titlecase}}</span>
          </mat-panel-title>
          <div class="item-end">
            <ng-container *ngIf="page && page.pageType && !excludedPageTypes.includes(page.pageType)">
              <button mat-icon-button 
                (click)="$event.stopPropagation();addPage(addPagePopUp,'edit',page.pageId,page.pageName)"><mat-icon>edit</mat-icon></button>
              <button mat-icon-button color="warn"
                (click)="$event.stopPropagation();deletePage(page?.pageId,deletePageErrorPopUp,page.pageName)"><mat-icon>delete</mat-icon></button>
              </ng-container>
          </div>
      </mat-expansion-panel-header>
      <mat-list class="mb-2" [formGroup]="pageNavAndMenGroup" *ngIf="page.pageType && [pageTypes.customPage,pageTypes.landingPage].includes(page.pageType)">
        <mat-list-item class="multiaction-toggle " [class.selected]="navMenuSelectedStatus == 'nav'"> 
          <div class="row-content">
            <div class="pointer-label" (click)="displayView(true)" >Nav Bar</div>
            <mat-slide-toggle  labelPosition="before" formControlName="navBarExists"></mat-slide-toggle>
          </div>
        </mat-list-item>
        <mat-list-item class="multiaction-toggle" [class.selected]="navMenuSelectedStatus == 'menu'">
          <div class="row-content" >
            <div class="pointer-label" (click)="displayView(false)" >Side Bar</div>
            <mat-slide-toggle  labelPosition="before" formControlName="menuBarExists"></mat-slide-toggle>
          </div> 
        </mat-list-item>
      </mat-list>
      <mat-accordion togglePosition="before">

          <mat-expansion-panel [expanded]="true" >
            <mat-expansion-panel-header >
              <mat-panel-title>
                Sections
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-accordion displayMode="flat" togglePosition="before">
              <ng-container *ngFor="let form of selectedPage.forms;let i = index">
                <ng-container *ngIf="form.formConfig?.formType === formTypes.navBar">
                  <mat-expansion-panel [expanded]="form?.open || false">
                    <mat-expansion-panel-header [class.active]="form?.open || false"
                      (click)="sectionFormRenderer(page,pageIndex,i,form,true)">
                      <mat-panel-title>
                        {{form.formLabel| titlecase}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-list>
                      <mat-list-item class="app-name" *ngFor="let widget of form.widgets;let j = index" class=""
                        [class.selected]="widget.open" (click)="checkWidgetEnabled(page,i,j,widget)">
                        <div class="app-name">
                          <p class="title">{{
                            widget?.widgetConfig?.element?.label||widget.widgetLabel || "Component" |
                            titlecase}}</p>
                          <mat-slide-toggle *ngIf="j > 1" [checked]="widget.widgetConfig?.enabled"
                            (change)="changeOn($event,j,i)"></mat-slide-toggle>
                        </div>
                      </mat-list-item>
                    </mat-list>
                    <form [formGroup]="FormGroup">
                      <mat-expansion-panel togglePosition="before">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{form.formLabel | titlecase}} Details</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="mat-form-field-container">
                          <mat-form-field class="w-100 rounded-0">
                            <mat-label>Key</mat-label>
                            <input matInput type="text" formControlName="key" />
                          </mat-form-field>
                          <mat-form-field class="w-100 rounded-0">
                            <mat-label>Form Label</mat-label>
                            <input matInput type="text" formControlName="label" />
                          </mat-form-field>
                          <div class="theming-color-items">
                            <div class="color-item">
                              <div class="content">
                                <div class="label">Background Color</div>
                                <div class="value">{{ FormGroup.get('bgColor')?.value }}</div>
                              </div>
                              <div [style.background-color]="FormGroup.get('bgColor')?.value" mat-ripple class="color-thumb">
                                <input type="color" formControlName="bgColor" />
                              </div>
                            </div>
                            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateForm()">Update
                              Form</button>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </form>
                  </mat-expansion-panel>
                </ng-container>
                <ng-container *ngIf="form.formConfig?.formType !== formTypes.navBar">
                  <mat-expansion-panel [expanded]="form?.open || false">
                    <mat-expansion-panel-header [class.active]="form?.open || false"
                      (click)="sectionFormRenderer(page,pageIndex,i,form,true)">
                      <mat-panel-title>
                        {{form.formLabel| titlecase}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-list>
                      <ng-container *ngFor="let widget of form.widgets;let j = index">
                          <mat-list-item [class.selected]="widget.open" (click)="widgetFormRenderer(page,i,j,widget)" >
                          <span class="d-flex align-items-center justify-content-between gap-3">
                            <span class="text-ellipsis">{{
                              widget?.widgetConfig?.element?.label||widget.widgetLabel || "Component" |
                              titlecase}}</span>
                              <div class="item-end control-buttons" *ngIf="page.pageType && widgetDeleteEnabledPages.includes(page.pageType)">
                                <button mat-icon-button color="warn" class="mat-small" 
                                (click)="onSideNavWidgetDeleteClick(i,form,widget?.widgetId,widget)"><mat-icon>delete</mat-icon></button>
                              </div>
                          </span>
                          </mat-list-item>
                      </ng-container>
                    </mat-list>
                  </mat-expansion-panel>
                </ng-container>
              </ng-container>
            </mat-accordion>
              <button mat-stroked-button color="primary" *ngIf="page.pageType !== pageTypes.loginPage" class="add-button w-100 mt-3" (click)="subNavValueSetter(page,sideNavContentOptions.addComponent)">
                <mat-icon>add</mat-icon> Add Component
              </button>
          </mat-expansion-panel>
        </mat-accordion>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>
<div class="p-3">
  <button mat-stroked-button color="primary" class="add-button w-100" (click)="addPage(addPagePopUp,'add')"><mat-icon>add</mat-icon> Add
    Page</button>
</div>

<ng-template #addPagePopUp >
  <div (keydown.escape)="closeTemplate()" (keydown.enter)="savePage()" (click)="onMouseClick()" [class.screenblur]="activeSpinner">
  <mat-dialog-content class="add-page-dailog">
  <div class="row">
    <div class="col-12" [formGroup] = "addPageForm">
      <h2>
      <span *ngIf="!editPage">Add Page</span>
      <span *ngIf="editPage">Edit Page</span>
      </h2>     
      <mat-form-field class="w-100" appearance="outline" [color]="((isPageNameExist) || isPagenameEmpty) ? 'warn':'primary'">
        <mat-label>Page Name</mat-label>
        <input matInput placeholder="Page Name" formControlName="name" (input)="onPageNameAdd($event)" />
        <mat-hint class="error-message" *ngIf="isPageNameExist">Page name already exists</mat-hint>
        <mat-hint class="error-message" *ngIf="isPagenameEmpty">Please fill the above textfield</mat-hint>
      </mat-form-field>
      <ng-container>
        <mat-label>Map above Page To Entity</mat-label>
        <div [formGroup]="entityForm">
          <ng-container *ngIf="entityFormEdit">
            <mat-radio-group aria-label="Select an option" formControlName="selection">
              <mat-radio-button value="existing">Select from existing</mat-radio-button>
              <mat-radio-button value="new">Create new entity</mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="w-100" appearance="outline" *ngIf="entityForm.get('selection')?.value == 'new'">
              <mat-label>Entity Name</mat-label>
              <input matInput placeholder="Entity Name" formControlName="name" [errorStateMatcher]="matInputError"/>
              <mat-hint class="error-message" *ngIf="entityForm.get('name')?.invalid && (entityForm.get('name')?.touched || entityForm.get('name')?.dirty) && !entityForm.get('name')?.hasError('entityExists')">Please fill the above textfield</mat-hint>
              <mat-hint class="error-message" *ngIf="entityForm.get('name')?.hasError('entityExists')">Entity name already exists!</mat-hint>
            </mat-form-field>
          </ng-container>
          <mat-form-field class="w-100" *ngIf="entityForm.get('selection')?.value != 'new'" appearance="outline">
            <mat-label>Entitys</mat-label>
            <mat-select matNativeControl formControlName="dropDownData" required placeholder="Select Entity">
              <ng-container *ngFor="let item of entityData">
                <mat-option [value]='item?.entity_id'>{{item?.entity_name}}</mat-option>
              </ng-container>
            </mat-select>
            <mat-hint class="error-message" *ngIf="entityData?.length==0">Entity not found. Please create an entity first</mat-hint>
            <mat-hint class="error-message" *ngIf="entityForm.get('dropDownData')?.invalid && (entityForm.get('dropDownData')?.touched || entityForm.get('dropDownData')?.dirty) && entityData?.length!=0">Please select the entity</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>
  </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-button (click)="closeTemplate()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="addPageForm.invalid || entityForm.invalid || (isPageNameExist)" (click)="savePage()">Save</button>
</mat-dialog-actions>
</div>
<div *ngIf="activeSpinner" [class.imageCenter]="activeSpinner">
  <mat-spinner diameter="30"></mat-spinner>  
</div>
</ng-template>

<ng-template #deletePageErrorPopUp >
  <div (keydown.escape)="closeTemplate()" >
    <div mat-dialog-title class="text-danger"><mat-icon class="position-Icon">warning</mat-icon><span class="title"> Unable to Delete "{{errorPage || 'Page'}}" Page</span></div>
  <mat-dialog-content class="add-page-dailog">
 <p>{{pageDeleteMessage}}</p>
 <p><small><strong>Note :</strong>Delete/Update Referencing Pages Or Mentioned Widgets.</small></p>

</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <button mat-raised-button color="primary" (click)="closeTemplate()">Ok</button>
</mat-dialog-actions>
</div>
</ng-template>